
































































































































import { Coupon } from "@/graphql/client";
import { Component, Ref, Emit, Mixins } from "vue-property-decorator";
import couponService from "@/service/couponService";
import ProgressLinear from "@/components/molecules/ProgressLinear.vue";
import MixinValidator from "@/components/mixins/coupon/MixinCouponEditDialogValidator.vue";
import MixinFormatter from "@/components/mixins/MixinFormatter.vue";

@Component({
  components: {
    ProgressLinear,
  },
})
export default class CouponEditDialog extends Mixins(
  MixinValidator,
  MixinFormatter
) {
  @Ref() readonly itemForm!: HTMLFormElement;
  //---------------------------
  // data
  //---------------------------
  isOpen = false;
  isProgressing = false;
  item: Coupon = couponService.defaultCoupon;
  valid = false;
  //---------------------------
  // mounted
  //---------------------------
  //---------------------------
  // computed
  //---------------------------
  /**
   * 「YYY-MM-DD HH:mm:ss」形式の登録日時を取得
   */
  get formattedCreatedAt(): string {
    return this.formatDateTime(this.item.createdAt);
  }
  /**
   * 「YYY-MM-DD HH:mm:ss」形式の更新日時を取得
   */
  get formattedUpdatedAt(): string {
    return this.formatDateTime(this.item.updatedAt);
  }

  //---------------------------
  // methods
  //---------------------------
  private async fetchData(item: Coupon) {
    this.item = couponService.defaultCoupon;
    if (item.guid) {
      const result = await couponService.getCoupon(item.guid);
      if (result) {
        this.item = result;
      }
    }
  }
  /**
   * ダイアログを表示します.
   */
  public open(item: Coupon): void {
    this.fetchData(item);

    this.isProgressing = false;
    this.isOpen = true;
  }

  /**
   * ダイアログを閉じます.
   */
  public close(): void {
    this.isProgressing = false;
    this.isOpen = false;
  }

  /**
   * 入力内容を保存します.
   */
  save(): void {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.isProgressing = true;
      if (this.item.guid) {
        //update
        couponService
          .updateCoupon(this.item)
          .then((result) => {
            this.isProgressing = true;
            this.notifyUpdateSuccess(result as Coupon);
          })
          .catch((err) => {
            console.error(err);
            this.notifyError("クーポンの更新ができませんでした.");
          });
      } else {
        //create
        couponService
          .createCoupon(this.item)
          .then((result) => {
            this.isProgressing = true;
            this.notifyCreateSuccess(result as Coupon);
          })
          .catch((err) => {
            console.error(err);
            this.notifyError("クーポンの登録ができませんでした.");
          });
      }
    }
  }

  /**
   * 登録成功
   */
  @Emit("onCreateSuccess")
  public notifyCreateSuccess(created: Coupon): Coupon {
    return created;
  }
  /**
   * 更新成功
   */
  @Emit("onUpdateSuccess")
  public notifyUpdateSuccess(updated: Coupon): Coupon {
    return updated;
  }
  /**
   * 失敗
   */
  @Emit("onError")
  public notifyError(message: string): string {
    return message;
  }
}
